/** Step within the two-step (Elite / Most Popular) scheduling flow. */
export enum SchedulingStep {
  Session = 'session',
  Presentation = 'presentation'
}
